import React from 'react';

const technologies = [
  "EC2", "S3", "Lambda", "RDS", "CloudFront", "Route 53", 
  "DynamoDB", "ECS", "EKS", "CloudWatch", "IAM", "VPC"
];

const TechnologiesSection = () => {
  return (
    <div className="py-16 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-extrabold text-white sm:text-4xl">
            AWS Technologies We Work With
          </h2>
          <p className="mt-4 max-w-2xl text-xl text-gray-300 mx-auto">
            Our expertise spans across all major AWS services
          </p>
        </div>

        <div className="mt-12 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6">
          {technologies.map((tech, index) => (
            <div 
              key={index} 
              className="bg-gray-800 h-20 rounded-md flex items-center justify-center border border-gray-700 p-2 hover:border-blue-500 transition-colors duration-150"
            >
              <span className="text-white font-medium text-center text-sm">{tech}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TechnologiesSection; 